import sanityClient from "../client";

class SanityFileUpload {
  constructor() {}

  // add a single file to the end of a Sanity array
  async appendFileToSanityArray(sanityDocumentId, file) {
    console.log("file");
    console.log(file);
    if (!sanityDocumentId) {
      throw new Error("sanityDocumentId must be truthy");
    }

    if (!file) {
      throw new Error("file must be truthy");
    }

    sanityClient.assets
      .upload("file", file)
      .then((document) => {
        console.log("The file was uploaded!", document);
        console.log("submitting request");
        sanityClient
          .patch(sanityDocumentId)
          //Ensure that the `medicalRecordsAvailableForReview` arrays exists before attempting to add items to it
          .setIfMissing({ medicalRecordsAvailableForReview: [] })
          // Add the items after the last item in the array (append)
          .append("medicalRecordsAvailableForReview", [
            {
              _type: "file",
              name: document.originalFilename,
              _key: document._id,
              asset: {
                _type: "reference",
                _ref: document._id,
              },
            },
          ])
          .commit({
            // Adds a `_key` attribute to array items, unique within the array, to
            // ensure it can be addressed uniquely in a real-time collaboration context
            autoGenerateArrayKeys: true,
          });
      })
      .catch((error) => {
        console.error("Upload failed:", error.message);
      });
  }
}

export default SanityFileUpload;
